import { render, staticRenderFns } from "./QuestionsCard.vue?vue&type=template&id=43874de8&scoped=true"
import script from "./QuestionsCard.vue?vue&type=script&lang=js"
export * from "./QuestionsCard.vue?vue&type=script&lang=js"
import style0 from "./QuestionsCard.vue?vue&type=style&index=0&id=43874de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43874de8",
  null
  
)

export default component.exports